<template>
  <CCard>
    <CCardHeader>
      <strong>{{ this.$lang.dashboard.header.recent_group }}</strong>
      <span style="float: right;">
        <CBadge color="success">{{ count }}</CBadge>
      </span>
    </CCardHeader>
    <CCardBody>
      <CDataTable class="mb-0 table-outline" hover :items="tableItems" :fields="tableFields"
                  @row-clicked="rowClickHandler" head-color="light" no-sorting>
        <td slot="title" slot-scope="{ item }">
          <span :title="item.title">{{ trimfunction(item.title, 15) }}</span>
        </td>
        <td slot="users" slot-scope="{ item }">
          <span>{{ item.users }}</span>
        </td>
        <td slot="shortName" slot-scope="{ item }">
          <span :title="item.shortName">{{ trimfunction(item.shortName, 15) }}</span>
        </td>
      </CDataTable>
      <CRow v-if="showProfile" style="margin-top: 2px">
        <CCol class="col-12 text-right">
          <button title="View All Profile" v-on:click="viewGroups" class="btn btn-light btn-block mb-1">
            View All
          </button>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import Vue from "vue";
import {ServerTable} from "vue-tables-2";
import store from "../../store/store";
import {Mixin} from "/src/mixins/index.js";
import {dashboardrecentGroupList} from "../../store/url";

Vue.use(ServerTable, {}, false);
export default {
  name: "RecentGroup",
  mixins: [Mixin],
  data() {
    return {
      self: this,
      count: 0,
      showProfile: false,
      moduleDashboardrecentGroupList: dashboardrecentGroupList,
      tableItems: [],
      tableFields: [
        {key: "title", label: this.$lang.dashboard.recentGroup.title},
        {key: "users", label: this.$lang.dashboard.recentGroup.users},
        {key: "shortName", label: this.$lang.dashboard.recentGroup.shortName},
      ],
    };
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    axios.get(this.listUrlApi(this.moduleDashboardrecentGroupList))
        .then((response) => {
          self.tableItems = response.data.data;
          self.count = response.data.count;
          if (response.data.data.length > 0) {
            self.showProfile = true;
          }
        });
  },
  methods: {
    rowClickHandler(item) {
      this.$router.push({path: `groups/detail/${item.groupId}`});
    },
    viewGroups() {
      this.$router.push({path: `groups`});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
